// Modules
import { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'

// Languages
import { LN_AUTH_PASSWORD } from 'locales/constants'

// Components
import { ErrorMessage, InputBase } from 'components'
import { formConstants } from 'pages/Auth/Login/LoginForm/constants'
import PasswordEyeIconBtn from 'pages/Auth/components/PasswordEyeIconBtn'

// UI
import { FormControl, FormLabel, InputGroup } from '@chakra-ui/react'

const PasswordField = (props) => {
  const { formik, placeholder, isLabel = true } = props

  const { t } = useTranslation()

  const { password } = formConstants

  const [showPassword, setShowPassword] = useState(false)

  return (
    <FormControl isRequired mb={3}>
      {isLabel && <FormLabel>{t(LN_AUTH_PASSWORD)}</FormLabel>}
      <InputGroup>
        <InputBase
          type={showPassword ? 'text' : 'password'}
          {...formik.getFieldProps(password)}
          placeholder={placeholder ? t(LN_AUTH_PASSWORD) : ''}
        />
        <PasswordEyeIconBtn showPassword={showPassword} setShowPassword={setShowPassword} />
      </InputGroup>
      {formik.touched[password] && formik.errors[password] && (
        <ErrorMessage error={t(formik.errors[password])} fontSize="sm" />
      )}
    </FormControl>
  )
}

export default memo(PasswordField)
